// routeConfig.js
import React from 'react';
import { SlCalender } from 'react-icons/sl';
import { GiFarmer } from 'react-icons/gi';
import { TbReportAnalytics } from 'react-icons/tb';
import { FaBugSlash, FaDatabase, FaTableList } from 'react-icons/fa6';
import { MdOutlineRule, MdOutlineSms } from 'react-icons/md';
import infection_alertIcon from 'assets/img/icons/weatherIcon.png';
import weather_alertIcon from 'assets/img/icons/weather_alert.png';
import overviewIcon from 'assets/img/icons/overview.png';
import alert_reportIcon from 'assets/img/icons/alert_reports.png';
import weather_forecastIcon from 'assets/img/icons/weather_forecast.png';
import demo_plotsIcon from 'assets/img/icons/demo_plots.png';
import smsIcon from 'assets/img/icons/sms.png';
import cultivationIcon from 'assets/img/icons/cultivation.png';
import farmer from 'assets/img/icons/farmer.png';
import satellite from 'assets/img/icons/satellite.png';
import settings from 'assets/img/icons/settings.png';
import reports from 'assets/img/icons/reports.png';
import dashboard from 'assets/img/icons/dashboard.png';
import sms_log_report from 'assets/img/icons/sms_log_report.png';
import crop_calendar from 'assets/img/icons/crop_calendar.png';
import field_officer from 'assets/img/icons/field_officer.png';
import procurement from 'assets/img/icons/procurement.png';
import market_price from 'assets/img/icons/market_price.png';
import farmer_group from 'assets/img/icons/farmer_group.png';
import center_list from 'assets/img/icons/center_list.png';
import offline_data from 'assets/img/icons/Offlinedata.png';
import processed_item from 'assets/img/icons/Processeditem.png';
import processed_stage from 'assets/img/icons/Processedstages.png';
import grade from 'assets/img/icons/Grade.png';
import center_addition from 'assets/img/icons/Center.png';
import traceability_settings from 'assets/img/icons/Traceabilitysettings.png';
import traceability_master from 'assets/img/icons/traceabilityMainMenu.png';
import OrderSummary from 'components/app/e-commerce/checkout/OrderSummary';

// Define base routes available to all clients
export const baseRoutes = {
  inputMarketplace: {
    name: 'Input Marketplace',
    img: market_price,
    path: 'input-marketplace',
    active: true,
    children: [
      'createProduct',
      'productCatalog',
      'manageWarehouses',
      'stockInReport',
      'stockReport',
      'myOrders',
      'ordersProductReport',
      'manageFulfillmentUser',
      'orderReturns',
      'stockTransfer',
      'consolidatedOrderHistory',
      'createSalesOrder',
      'marketplaceSalesOrderReport',
      'addPromos',
      'purchaseOrderRequest',
      'purchaseOrder',
      'stockReturn',
      'distributionPartnerManagement'
    ]
  }
};

// Define client-specific route configurations
export const clientRoutes = {
  AMBUJAFOUNDATION: {
    additionalRoutes: ['comparison', 'villageLevel', 'farmLevel', 'monitoring']
  },
  MRV: {
    additionalRoutes: [
      'monitoring',
      'comparison',
      'villageLevel',
      'perilAlerts',
      'cultivationReport',
      'farmerReport',
      'farmlandReport',
      'farmerGroupReport',
      'weatherReport',
      'dashboardAnalytics',
      'plotOverlay',
      'farmLevel',
      'cropInfectionReport',
      'smsManagement',
      'smslogReport',
      'cropInfectionRuleReport',
      'smsDashboard',
      'cropCalendarReport',
      'fieldOfficerReport',
      'cropcalendarRuleReport',
      'marketpriceReport',
      'pulaFarmlandReport',
      'exportFarmlandReport'
    ]
  },
  RPLC: {
    additionalRoutes: ['monitoring', 'comparison', 'plotOverlay', 'farmLevel']
  },
  SESTA: {
    additionalRoutes: ['monitoring', 'comparison']
  },
  TNSMRV: {
    additionalRoutes: [
      'dashboard',
      'alertsReport',
      'satelliteMRV',
      'reports',
      'settings',
      'offlineData'
    ]
  }
};

// Define additional routes that can be added based on client
export const additionalRoutes = {
  monitoring: {
    name: 'Monitoring',
    icon: SlCalender,
    path: 'monitor',
    active: true
  },
  villageLevel: {
    name: 'Village Level Data',
    icon: FaTableList,
    path: 'village',
    active: true
  },
  perilAlerts: {
    name: 'Peril Alerts',
    icon: TbReportAnalytics,
    path: 'perilAlerts',
    active: true
  },
  weatherReport: {
    name: 'Weather Forecast Report',
    icon: TbReportAnalytics,
    path: 'weatherReport',
    active: true
  },
  dashboardAnalytics: {
    name: 'Dashboard Analytics',
    icon: TbReportAnalytics,
    path: 'dashboardAnalytics',
    active: true
  },
  plotOverlay: {
    name: 'Plot Overlay & Comparison',
    icon: GiFarmer,
    path: 'plotoverlay',
    active: true
  },
  farmLevel: {
    name: 'Farm-level Report',
    icon: TbReportAnalytics,
    path: 'farmlevelReport',
    active: true
  },
  smslogReport: {
    name: 'SMS Log Report',
    icon: MdOutlineSms,
    path: 'smslogReport',
    active: true
  },
  comparison: {
    name: 'Comparison',
    icon: GiFarmer,
    path: 'comparison',
    active: true
  },
  cropInfectionReport: {
    name: 'Crop Infection Report',
    icon: FaBugSlash,
    path: 'cropInfection/report',
    active: true
  },
  cropInfectionRuleReport: {
    name: 'Crop Infection Rule Report',
    icon: MdOutlineRule,
    path: 'cropInfection/rules/report',
    active: true
  },
  marketpriceReport: {
    name: 'Market Price Report',
    icon: TbReportAnalytics,
    path: 'marketpriceReport',
    img: market_price,
    active: true
  },
  farmerGroupReport: {
    name: 'Cooperative',
    icon: MdOutlineSms,
    path: 'farmerGroupReport',
    img: farmer_group,
    active: true
  },
  fieldOfficerReport: {
    name: 'Trader',
    icon: TbReportAnalytics,
    path: 'fieldOfficerReport',
    img: field_officer,
    active: true
  },
  cropcalendarRuleReport: {
    name: 'Crop Calendar Rule Report',
    icon: TbReportAnalytics,
    path: 'cropcalendarRuleReport',
    img: crop_calendar,
    active: true
  },
  procurementReport: {
    name: 'Procurement',
    icon: TbReportAnalytics,
    path: 'procurementReport',
    img: procurement,
    active: true
  },
  overview: {
    name: 'Overview',
    icon: MdOutlineSms,
    path: 'dashboardAnalytics',
    active: true,
    img: overviewIcon
  },
  sms: {
    name: 'SMS',
    icon: MdOutlineSms,
    path: 'sms-dashboard',
    active: true,
    img: smsIcon
  },
  dashboard: {
    name: 'Dashboard',
    icon: MdOutlineSms,
    path: 'dashboard',
    active: true,
    img: dashboard
  },
  traceabilityDashboard: {
    name: 'Dashboard',
    icon: MdOutlineSms,
    path: 'traceabilityDashboard',
    active: true,
    img: dashboard
  },
  weatherForecast: {
    name: 'Weather Forecast',
    icon: SlCalender,
    path: 'weatherReport',
    active: true,
    img: weather_forecastIcon
  },
  infectionAlert: {
    name: 'Infection Alert',
    icon: FaBugSlash,
    path: 'cropInfection/report',
    active: true,
    img: infection_alertIcon
  },
  weatherAlert: {
    name: 'Weather Alert',
    icon: SlCalender,
    path: 'perilAlerts',
    active: true,
    img: weather_alertIcon
  },
  alertsReport: {
    name: 'Alerts Report',
    icon: SlCalender,
    path: 'alerts',
    active: true,
    img: alert_reportIcon
  },
  demoPlots: {
    name: 'Demo Plots',
    icon: GiFarmer,
    path: 'farmlevelReport',
    active: true,
    img: demo_plotsIcon
  },
  satelliteMRV: {
    name: 'Satellite MRV',
    icon: GiFarmer,
    path: 'satellite-mrv',
    active: true,
    img: satellite
  },
  farmerReport: {
    name: 'Farmer',
    icon: TbReportAnalytics,
    path: 'farmerReport',
    active: true,
    img: farmer
  },
  farmlandReport: {
    name: 'Farmland',
    icon: TbReportAnalytics,
    path: 'farmlandReport',
    active: true,
    img: demo_plotsIcon
  },
  exportFarmlandReport: {
    name: 'Export Farmland Report',
    icon: TbReportAnalytics,
    path: 'exportFarmlandReport',
    active: true,
    img: demo_plotsIcon
  },
  cultivationReport: {
    name: 'Cultivation Report',
    icon: TbReportAnalytics,
    path: 'cultivationReport',
    active: true,
    img: cultivationIcon
  },
  smsLogReport: {
    name: 'SMS Log Report',
    icon: TbReportAnalytics,
    path: 'smslogReport',
    active: true,
    img: sms_log_report
  },
  reports: {
    name: 'Reports',
    icon: TbReportAnalytics,
    path: 'reports',
    active: true,
    img: reports
  },
  Traceability: {
    name: 'Traceability',
    icon: TbReportAnalytics,
    path: 'Traceability',
    active: true,
    img: traceability_master
  },
  Organization: {
    name: 'Organization',
    icon: TbReportAnalytics,
    path: 'Organization',
    active: true,
    img: overviewIcon
  },
  traceabilitySettings: {
    name: 'Traceability Master',
    icon: TbReportAnalytics,
    path: 'Traceability',
    active: true,
    img: traceability_settings
  },
  cropCalendarReport: {
    name: 'Crop Calendar Report',
    icon: FaTableList,
    path: 'crop-calendar-report',
    img: crop_calendar,
    active: true
  },
  smsManagement: {
    name: 'SMS Management',
    icon: MdOutlineSms,
    path: 'sms-management',
    active: true,
    img: smsIcon
  },
  infectionRuleManagement: {
    name: 'Infection Rule Management',
    icon: MdOutlineRule,
    path: 'cropInfection/rules/report',
    active: true,
    img: infection_alertIcon
  },
  settings: {
    name: 'Settings',
    icon: MdOutlineSms,
    path: 'settings',
    active: true,
    img: settings
  },
  offlineData: {
    name: 'Offline Data',
    icon: MdOutlineSms,
    path: 'offline/data',
    active: true,
    img: offline_data
  },
  centerListReport: {
    name: 'Center Addition',
    icon: TbReportAnalytics,
    path: 'centerList',
    active: true,
    img: center_addition
  },
  receptionReport: {
    name: 'Receive Items',
    icon: TbReportAnalytics,
    path: 'receptionReport',
    active: true,
    img: center_list
  },
  transferReport: {
    name: 'Transfer Items',
    icon: TbReportAnalytics,
    path: 'transferReport',
    active: true,
    img: center_list
  },
  processReport: {
    name: 'Process Crops',
    icon: TbReportAnalytics,
    path: 'processReport',
    active: true,
    img: center_list
  },
  processedItemReport: {
    name: 'Manage Processed Item',
    icon: TbReportAnalytics,
    path: 'processedItemReport',
    active: true,
    img: processed_item
  },
  processedStageReport: {
    name: 'Manage Processed Stages',
    icon: TbReportAnalytics,
    path: 'processedStageReport',
    active: true,
    img: processed_stage
  },
  gradeItemReport: {
    name: 'Manage Grade',
    icon: TbReportAnalytics,
    path: 'gradeItemReport',
    active: true,
    img: grade
  },
  habitatMonitor: {
    name: 'Habitat Monitoring',
    icon: TbReportAnalytics,
    path: 'habitat',
    active: true,
    img: center_list
  },
  cropItemReport: {
    name: 'Crop Report',
    icon: TbReportAnalytics,
    path: 'cropItemReport',
    active: true,
    img: grade
  },
  cropVarietyItemReport: {
    name: 'Crop Variety Report',
    icon: TbReportAnalytics,
    path: 'cropVarietyItemReport',
    active: true,
    img: grade
  },
  userReport: {
    name: 'Traceability User',
    icon: TbReportAnalytics,
    path: 'traceabilityUserReport',
    active: true,
    img: grade
  },
  moduleReport: {
    name: 'Module Report',
    icon: TbReportAnalytics,
    path: 'moduleReport',
    active: true,
    img: grade
  },
  pulaFarmlandReport: {
    name: 'Farmland',
    icon: TbReportAnalytics,
    path: 'pulaFarmlandReport',
    active: true,
    img: demo_plotsIcon
  },
  inventory: {
    name: 'Inventory',
    img: processed_item,
    path: 'inventory',
    active: true
  },
  createProduct: {
    name: 'Create Product',
    path: 'create-product',
    img: processed_item,
    active: true
  },
  productCatalog: {
    name: 'My Product Catalog',
    path: 'product-catalog',
    active: true
  },
  manageWarehouses: {
    name: 'Manage Warehouses',
    path: 'manage-warehouses',
    active: true
  },
  stockInReport: {
    name: 'Stock In',
    path: 'stock-in-report',
    icon: TbReportAnalytics,
    active: true
  },
  createStockIn: {
    name: 'Create Stock In',
    path: 'create-stock-in',
    active: true
  },
  stockReport: {
    name: 'My Stock Report',
    path: 'stock-report',
    icon: TbReportAnalytics,
    active: true
  },
  myOrders: {
    name: 'My Orders',
    path: 'my-orders',
    active: true
  },
  ordersProductReport: {
    name: 'My Orders Product Report',
    path: 'orders-product-report',
    active: true
  },
  manageFulfillmentUser: {
    name: 'Manage Fulfillment User',
    path: 'manage-fulfillment-user',
    active: true
  },
  orderReturns: {
    name: 'Order Returns',
    path: 'order-returns',
    active: true
  },
  stockTransfer: {
    name: 'Stock Transfer',
    path: 'stock-transfer',
    icon: TbReportAnalytics,
    active: true
  },
  consolidatedOrderHistory: {
    name: 'Consolidated Order History',
    path: 'consolidated-order-history',
    active: true
  },
  createSalesOrder: {
    name: 'Create Sales Order',
    path: 'create-sales-order',
    active: true
  },
  marketplaceSalesOrderReport: {
    name: 'Sales Order Report',
    path: 'sales-order-report',
    active: true
  },
  categoryReport: {
    name: 'Category',
    path: 'category-report',
    icon: TbReportAnalytics,
    active: true
  },
  productReport: {
    name: 'Products',
    path: 'product-report',
    icon: TbReportAnalytics,
    active: true
  },
  createCategory: {
    name: 'Create Category',
    path: 'create-category',
    active: true
  },
  supplierReport: {
    name: 'Supplier',
    path: 'supplier-report',
    icon: TbReportAnalytics,
    active: true
  },
  customerReport: {
    name: 'Customer',
    path: 'customer-report',
    icon: TbReportAnalytics,
    active: true
  },
  createSupplier: {
    name: 'Create Supplier',
    path: 'create-supplier',
    active: true
  },
  createCustomer: {
    name: 'Create Customer',
    path: 'create-customer',
    active: true
  },
  addPromos: {
    name: 'Add Promos',
    path: 'add-promos',
    active: true
  },
  purchaseOrderRequest: {
    name: 'Purchase Order Request',
    path: 'purchase-order-request',
    active: true
  },
  purchaseOrder: {
    name: 'Purchase Order',
    path: 'purchase-order',
    icon: TbReportAnalytics,
    active: true
  },
  createPurchaseOrder: {
    name: 'Create Purchase Order',
    path: 'create-purchase-order',
    active: true
  },
  stockReturn: {
    name: 'Stock Return',
    path: 'stock-return',
    icon: TbReportAnalytics,
    active: true
  },
  distributionPartnerManagement: {
    name: 'Distribution Partner Management',
    path: 'distribution-partner-management',
    active: true
  },
  salesOrderReport: {
    name: 'Sales Order',
    icon: TbReportAnalytics,
    path: 'salesOrderReport',
    active: true,
    img: procurement
  }
};
